import {
  MaatNcqStatus as SERVICE_WORKER_MaatNcqStatus,
  MaatNcqStatusDescriptions as SERVICE_WORKER_MaatNcqStatusDescriptions
} from '../../../../ServiceWorker/src/constants/maat-ncq-status.constants';

export { SERVICE_WORKER_MaatNcqStatus as MaatNcqStatus };
export { SERVICE_WORKER_MaatNcqStatusDescriptions as MaatNcqStatusDescriptions };
